import { jwtDecode } from 'jwt-decode';

/**  Custom components stores services types constant */
import axiosInstance from '../../services/http.api';
import { DEFAULT_ERROR_MSG } from '../../utils/constants';

/******************** Interfaces *******************/
export interface ActivityData {
    id: string,
    description: string,
    sharedBy: string,
    lastModifiedDate: string
}

/**************** Constants ********************** */
const COMMENTS_SUCCEESSFULL_ADDED_MSG = "Comments has been added successfully";
const COMMENTS_ADDED_FAIL_MSG = "Error while adding comments.";
const COMMENTS_FETCH_FAIL_MSG = "Error while adding comments.";

// Export all constants
export const MessageConstants = {
   COMMENTS_SUCCEESSFULL_ADDED_MSG,
   COMMENTS_ADDED_FAIL_MSG,
   COMMENTS_FETCH_FAIL_MSG
}

export const messageService = {

    trimShareBy : (message: string) => {
       const trimmed = message.trim().endsWith("to") ? message.trim().slice(0, -2).trimEnd(): message;
       return trimmed;
    },

    /**
     * Fetch activities
     * @param logoRequestId 
     * @returns 
     */
    fetchActivities: async (logoRequestId: string): Promise<ActivityData[]> => {
        try {
             const res = await axiosInstance.get<any>(`/v1/Messaging/messages/logo/${logoRequestId}`);
 
             if (!res.data.isSuccess) {
                 // Throw an error with custom message
                 throw new Error(res.data.message || DEFAULT_ERROR_MSG);
             }
 
             const data = res.data.messages || [];

             // Sort lastModifiedDate by Desc
             const sortedData = data.sort((a: any, b: any) => 
                                new Date(a.lastModifiedDate).getTime() - new Date(b.lastModifiedDate).getTime()
                                );

             const messageList: ActivityData[] = sortedData.map((item: any) => ({
                 id : item.id,
                 description: item.messageBody ? item.messageBody : "",
                 sharedBy: item.messageSharedBy ? item.messageSharedBy.replace(/\s+to$/, "")  : "",
                 lastModifiedDate: item.lastModifiedDate ? item.lastModifiedDate : ""
             }));  
   
            return messageList;

        } catch (error: any) {
            throw new Error(error?.response?.data?.message || COMMENTS_FETCH_FAIL_MSG);
        }
    },

    /**
     * Add new message
     * @param messageBody 
     * @param logoRequestId 
     * @returns 
     */
    addMessage: async (messageBody: string, logoRequestId: string): Promise<boolean> => {
        try {
            if (logoRequestId === '') {
                throw new Error(DEFAULT_ERROR_MSG);
            }
            const reuqestData = { 'messageBody': messageBody, 'recordType': 0, 'logoRequest': logoRequestId };
            const res = await axiosInstance.post<any>('/v1/Messaging', reuqestData);

            let data = res.data;

            if (!data.isSuccess) {
                // Throw an error with custom message
                throw new Error(data.message || DEFAULT_ERROR_MSG);
            }

            return data.isSuccess;

        } catch (error: any) {
            throw new Error(error?.response?.data?.message || COMMENTS_ADDED_FAIL_MSG);
        }
    }

}